import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import OutsideClickHandler from "react-outside-click-handler";
import cn from "classnames";
import styles from "./Modal.module.sass";
import Icon from "../Icon";

const Modal = ({
	outerClassName,
	visible,
	onClose,
	children,
	outSideClickNone = false,
}) => {
	const thisId = useRef(Date.now());
	useEffect(() => {
		if (visible) {
			const target = document.querySelector(`#M${thisId.current}`);
			disableBodyScroll(target);
		} else {
			clearAllBodyScrollLocks();
		}
	}, [visible]);

	return createPortal(
		visible && (
			<div id={`M${thisId.current}`} className={styles.modal}>
				<div className={cn(styles.outer, outerClassName)}>
					<OutsideClickHandler
						onOutsideClick={() => {
							!outSideClickNone && onClose();
						}}
					>
						{children}
						<button className={styles.close} onClick={onClose}>
							<Icon name="close" size="20" />
						</button>
					</OutsideClickHandler>
				</div>
			</div>
		),
		document.body
	);
};

export default Modal;
